var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 8,
  viewBox: "0 0 13 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.09 0.589844L6.5 5.16984L1.91 0.589844L0.5 1.99984L6.5 7.99984L12.5 1.99984L11.09 0.589844Z",
  fill: "black"
})));
export { SvgChevron as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEzIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS4wOSAwLjU4OTg0NEw2LjUgNS4xNjk4NEwxLjkxIDAuNTg5ODQ0TDAuNSAxLjk5OTg0TDYuNSA3Ljk5OTg0TDEyLjUgMS45OTk4NEwxMS4wOSAwLjU4OTg0NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";